<script>
import Victim from "../victim.js";

export default {
  data() {
    return {
      allVictims: [],
      loadError: null
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.allVictims = await Victim.loadData();
      } catch (e) {
        this.loadError = e;
        return;
      }
    }
  },
  computed: {
    loading() {
      return this.allVictims.length === 0;
    },
    loadingMsg() {
      if (!this.loading) {
        return "";
      }
      if (!this.loadError) {
        return "Loading data…";
      }
      return "There was an error loading data…";
    }
  }
};
</script>
